'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkPoiGroup } from '../../../types';
import { Poi } from '../Poi/poi';

export const PoiGroup: React.FC<LlmBlock<LlmChunkPoiGroup>> = (props) => {
  const { item } = props;
  const classNames = getClassNames('llm__pois');
  return (
    <div className={classNames}>
      {item.items.map((item, i) => (
        <Poi key={i}{...props} item={item} />
      ))}
    </div>
  );
};

